import { Link } from "react-router-dom";
import { LandingNav, HeroVision } from "@/components/landing/HeroVision";
import { ChildhoodFree } from "@/components/landing/ChildhoodFree";
import { SeasonsShowcase } from "@/components/landing/SeasonsShowcase";
import { HowItWorks, PrivacyPromise } from "@/components/landing/HowItWorks";
import { GiftSection, LifetimeInvite } from "@/components/landing/GiftAndLifetime";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FAF6F0] text-[#2D2824]">
      <LandingNav />
      <HeroVision />
      <GiftSection />
      <ChildhoodFree />
      <SeasonsShowcase />
      <HowItWorks />
      <PrivacyPromise />
      <LifetimeInvite />
      <section data-testid="landing-signin" className="px-4 pb-20 text-center sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#36858B]">Already have a diary?</p>
        <h2 className="mt-2 font-serif text-3xl text-[#2D2824]">Welcome back</h2>
        <Link to="/account" data-testid="landing-signin-btn"
          className="mt-6 inline-flex rounded-full border-2 border-[#36858B] px-8 py-3 font-semibold text-[#36858B] transition-colors hover:bg-[#36858B] hover:text-white">
          Sign In
        </Link>
      </section>
    </div>
  );
}
